import { render, staticRenderFns } from "./DocumentsCategoryFilter.vue?vue&type=template&id=74c7c2ac"
import script from "./DocumentsCategoryFilter.vue?vue&type=script&lang=js"
export * from "./DocumentsCategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCategoryFilter.vue?vue&type=style&index=0&id=74c7c2ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports